import { Api } from "@noom/noomscape";

import axios from "axios";

Api.register(
  "healthRecords.scheduleHealthRecordsRetrieval",
  async ({
    accessCode,
    accessToken,
  }: {
    accessCode: string;
    accessToken: string;
  }): Promise<void> => {
    await axios({
      baseURL: window.ENV.HEALTHCARE_SERVER_URL,
      method: "POST",
      url: `/externalHealthData/${accessCode}/scheduleHealthRecordsRetrieval`,
      urlWithPathParams: "/externalHealthData/{accessCode}/scheduleHealthRecordsRetrieval",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },
);
